import styled from "styled-components";
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow'

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#eef0f3",
        color: "#171A1FFF",
        boxShadow: 'none!important',
        position: 'sticky',
        top: 0,
        zIndex: 2,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
       // backgroundColor: theme.palette.action.hover,
        color: "#171A1FFF"
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export const PhoneNumberList = styled.ul`
    list-style: none;
    border: 1px solid #eee;
    width: auto;
    margin: 0;
    text-align: left;
    padding: 0;
    height: 100px;
    overflow-y: scroll;
    position: absolute;
    top: 53%;
    width: 100%;
    background-color: white;
`
export const PhoneNumber = styled.li`
    font-size: 12px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    z-index: 999;
`